var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile-app_dev",
    "data-name": "mobile-app dev",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.821,
    height: 119.043,
    viewBox: "0 0 80.821 119.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21910",
    "data-name": "Path 21910",
    d: "M36.782,16.2l-10.1-5.836a5.074,5.074,0,0,0-5.051,0L11.526,16.2A5.05,5.05,0,0,0,9,20.575V32.237a5.05,5.05,0,0,0,2.526,4.375l10.1,5.836a5.057,5.057,0,0,0,5.051,0l10.1-5.836a5.05,5.05,0,0,0,2.526-4.375V20.575A5.05,5.05,0,0,0,36.782,16.2ZM29.205,29.321l-5.051,2.915L19.1,29.321V23.491l5.051-2.915,5.051,2.915Z",
    transform: "translate(16.257 39.513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21911",
    "data-name": "Path 21911",
    d: "M64.616,2H24.205C13.064,2,4,12.678,4,25.809V97.234c0,13.131,9.064,23.809,20.205,23.809H64.616c11.141,0,20.205-10.678,20.205-23.809V25.809C84.821,12.678,75.757,2,64.616,2Zm10.1,95.234c0,6.562-4.531,11.9-10.1,11.9H24.205c-5.572,0-10.1-5.342-10.1-11.9V25.809c0-6.562,4.531-11.9,10.1-11.9H64.616c5.572,0,10.1,5.342,10.1,11.9Z",
    transform: "translate(-4 -2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21912",
    "data-name": "Path 21912",
    d: "M15.051,15.1h10.1a5.051,5.051,0,1,0,0-10.1h-10.1a5.051,5.051,0,1,0,0,10.1Z",
    transform: "translate(20.308 10.154)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.31eaf2d7df1e73f85aed99745831d03f.svg";
export { ForwardRef as ReactComponent };